var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
var loadingBarCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n\n  position: absolute;\n  height: 100%;\n"], ["\n  background-color: ", ";\n\n  position: absolute;\n  height: 100%;\n"
    /**
     * When `loading` is true or a number less than 0 or greater than 100,
     * the indeterminate progress bar styles will be used.
     * When `isLoading` is a number between 0 and 100, the determinate
     * progress bar will be used.
     */
])), function (_a) {
    var colors = _a.theme.colors, variant = _a.variant;
    switch (variant) {
        case 'secondary':
            return colors['blue-200'];
        case 'outline':
            return colors['blue-200'];
        case 'disabled':
            return colors['gray-300'];
        case 'login':
            return colors['teal-700'];
        case 'destructive':
            return colors['red-700'];
        case 'primary':
        default:
            return colors['blue-900'];
    }
});
/**
 * When `loading` is true or a number less than 0 or greater than 100,
 * the indeterminate progress bar styles will be used.
 * When `isLoading` is a number between 0 and 100, the determinate
 * progress bar will be used.
 */
export var LoadingBar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), loadingBarCss, function (_a) {
    var loading = _a.loading;
    return typeof loading === 'number'
        ? "width: ".concat(loading, "%;\n        left: 0;\n        transition: width 0.3s;")
        : "width: 60%;\n        position: absolute;\n      \n        left: -60%;\n        animation: load 2s ease infinite;\n\n        @keyframes load {\n          0% {\n            left: -60%;\n          }\n          100% {\n            left: 100%;\n          }\n        }\n  ";
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=LoadingBar.js.map